<rk-loader [size]="60" [center]="true" [isLoading]="true"></rk-loader>
